import { render, staticRenderFns } from "./MainLedgerCompindex.vue?vue&type=template&id=3a6a9e3c&scoped=true"
import script from "./MainLedgerCompindex.vue?vue&type=script&lang=js"
export * from "./MainLedgerCompindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a9e3c",
  null
  
)

export default component.exports